import { html } from "../../../../../jb-nexus/node_modules/lit";
import { NexusComponent } from "./nexus.component";

export class LanguageSwitcher extends NexusComponent {
  constructor() {
    super();
    this.supportedLanguages = ["en", "nl"];
  }

  get languages() {
    return this.querySelectorAll(".language-switcher-lang");
  }

  get urlLang() {
    const langs = this.supportedLanguages.join("|");
    const regex = new RegExp(`^\\/(${langs})(\\/|$)`);
    const match = window.location.pathname.match(regex);
    return match ? match[1] : null;
  }

  get activeLanguage() {
    return Array.from(this.languages).find(
      (language) => language.dataset.lang === this.activeLanguageCode
    );
  }

  get activeLanguageCode() {
    if (this.urlLang) return this.urlLang;

    const lang = document.querySelector("html").getAttribute("lang") || "";
    const short = lang.split("-")[0]; 
    if (this.supportedLanguages.includes(short)) {
      return short;
    }

    return "en";
  }

  get otherLanguageCode() {
    return this.supportedLanguages.find((l) => l !== this.activeLanguageCode);
  }

  connectedCallback() {
    super.connectedCallback();
    this.setActiveLanguage();
    this.addEventListener("click", this.handleLanguageSwitch);
  }

  setActiveLanguage() {
    this.activeLanguage.classList.add("fw-bold");
  }

  handleLanguageSwitch(event) {
    event.preventDefault();
    window.location.href = this.getNewUrl();
  }

  getNewUrl() {
    const htmlLang = document.querySelector("html").getAttribute("lang") || "";
    const defaultLang = htmlLang.split("-")[0];

    const actualDefault = this.supportedLanguages.includes(defaultLang)
      ? defaultLang
      : this.supportedLanguages[0];

    const segments = window.location.pathname.split("/").filter((s) => s);
    const urlLang = this.supportedLanguages.includes(segments[0])
      ? segments[0]
      : null;
    const rest = urlLang ? segments.slice(1) : segments;
    const pathWithoutLang = "/" + rest.join("/");

    const currentLang = urlLang || actualDefault;
    const otherLang = this.supportedLanguages.find((l) => l !== currentLang);

    if (otherLang === actualDefault) {
      return pathWithoutLang === "/" ? "/" : pathWithoutLang;
    } else {
      return pathWithoutLang === "/"
        ? `/${otherLang}`
        : `/${otherLang}${pathWithoutLang}`;
    }
  }

  render() {
    return html` <slot></slot> `;
  }
}

customElements.define("language-switcher", LanguageSwitcher);